export const SIGN_UP_CLEAR = 'SIGN_UP_CLEAR';
export const SIGN_UP_SAVE_STEP = 'SIGN_UP_SAVE_STEP';
export const SIGN_UP_SET_PASSWORD_STRENGTH = 'SIGN_UP_SET_PASSWORD_STRENGTH';
export const SIGN_UP_SHOW_WEAK_PASSWORD_POP_UP = 'SIGN_UP_SHOW_WEAK_PASSWORD_POP_UP';
export const SIGN_UP_HIDE_WEAK_PASSWORD_POP_UP = 'SIGN_UP_HIDE_WEAK_PASSWORD_POP_UP';
export const SIGN_UP_HIDE_EMAIL_EXISTS_POP_UP = 'SIGN_UP_HIDE_EMAIL_EXISTS_POP_UP';
export const SIGN_UP_START = 'SIGN_UP_START';
export const SIGN_UP_FINISH = 'SIGN_UP_FINISH';
